module.exports = __webpack_public_path__ + "img/bn.7d97ea7e.svg";